import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Course } from "../../models/course"

@Injectable({
  providedIn: "root",
})
export class CourseDisplayDataResolver
  implements DisplayDataResolver<Course>
{
  typeDisplayName = "Course"

  constructor() {}

  getIcon(entity: Course): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Course): string | undefined {
    return undefined
  }

  getSubTitle(entity: Course): string | undefined {
    return undefined
  }

  getTitle(entity: Course): string {
    return entity.name
  }

  getShortTitle(entity: Course): string {
    return entity.id
  }

  getItemHref(entityOrID: Course | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/course"
    }
    if (typeof entityOrID === "string") return "/app/course/" + entityOrID
    return "/app/course/" + entityOrID.id
  }
}
